import HouseIcon from "@redotech/redo-icons/home-02.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.addressVerified;

export const AddressVerifiedFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: HouseIcon,
  displayName: entry.displayName,
  label: "Address",
  boolDisplay: { falseDisplay: "unverified", trueDisplay: "verified" },
};
